import {useCallback} from 'react';
import {SettingsScreen} from '.';
import {useModalTask} from '../../../services';

export const useSettingsTask = (
  userId: number | undefined,
  firstname: string | undefined,
  lastname: string | undefined,
) => {
  const retVal = useModalTask<boolean>(SettingsScreen);
  return useCallback(() => {
    if (userId && firstname && lastname) {
      retVal({userId, firstname, lastname});
    }
  }, [firstname, lastname, retVal, userId]);
};
